<div [ngClass]="{ 'debounce-search-container': true, active: this.active }" [ngStyle]="{ width: this.width }">
  <input
    class="debounce-search"
    type="text"
    [(ngModel)]="this.searchString"
    [ngModelOptions]="{ standalone: true }"
    [placeholder]="this.placeholder"
    [ngStyle]="{ fontSize: this.fontSize }"
  />
  <button
    [ngClass]="{ 'clear-icon-button': true, show: this.searchString !== '' }"
    (click)="this.searchString !== '' ? this.handleClearSearch() : ''"
  >
    <mat-icon class="clear-icon" [fontIcon]="'close'" aria-hidden="true"></mat-icon>
  </button>
</div>
